import { CartLinesUpdateEvent } from '@shopify/events';

// Shipping Protection toggle: add/remove the protection line and let Horizon re-render the cart sections.
if (!window.__spBound) {
  window.__spBound = true;

  const sectionIds = () =>
    [...new Set([...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean))];

  async function update(el, { add, key, variant }) {
    const ids = sectionIds();
    const deferred = CartLinesUpdateEvent.createPromise();
    el.dispatchEvent(new CartLinesUpdateEvent(add
      ? { action: 'add', context: 'product', lines: [{ merchandiseId: variant, quantity: 1 }], promise: deferred.promise }
      : { action: 'remove', context: 'cart', lines: [{ id: key, quantity: 0 }], promise: deferred.promise }));
    try {
      const res = await fetch(add ? '/cart/add.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(add
          ? { items: [{ id: Number(variant), quantity: 1 }], sections: ids.join(','), sections_url: location.pathname }
          : { id: key, quantity: 0, sections: ids.join(','), sections_url: location.pathname }),
      }).then((r) => r.json());
      const cart = await fetch('/cart.js').then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'ship-protect', sections: res.sections, didError: !!res.status },
      });
    } catch (err) {
      deferred.reject(err);
    }
  }

  const setOptOut = (v) =>
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { sp_optout: v } }) });

  document.addEventListener('change', async (e) => {
    const box = e.target.closest?.('[data-sp-toggle]');
    if (!box) return;
    box.disabled = true;
    await setOptOut(box.checked ? '' : '1');   // remember the customer's choice for this cart
    if (box.checked && !box.dataset.key) return update(box, { add: true, variant: box.dataset.variant });
    if (!box.checked && !box.dataset.key) return location.pathname === '/cart' ? location.reload() : (box.disabled = false);
    update(box, { add: box.checked, key: box.dataset.key, variant: box.dataset.variant });
  });

  // If everything else was removed, drop the orphaned protection line too.
  // On by default: add protection once the cart has items (unless the customer switched it off).
  let busy = false;
  const check = () => {
    if (busy) return;
    const orphan = document.querySelector('[data-sp-orphan]');
    const auto = document.querySelector('[data-sp-autoadd]');
    if (!orphan && !auto) return;
    busy = true;
    const job = orphan
      ? update(orphan, { add: false, key: orphan.dataset.spOrphan })
      : update(auto, { add: true, variant: auto.dataset.spAutoadd });
    job.finally(() => { setTimeout(() => { busy = false; check(); }, 600); });
  };
  new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
  check();
}
